module.exports = __webpack_public_path__ + "7d8d2f034c8f80491198f8a5611c052f.svg";


//////////////////
// WEBPACK FOOTER
// ./client/assets/images/Logo-01.svg
// module id = 258
// module chunks = 0